import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { LanguageTranslatePopup } from '../popup/language-translate/language-translate.popup';
import { MenuItemBookModel } from '../../models/menu-item-book.model';
import { MenuItemBookDetailModel } from '../../models/menu-item-book-detail.model';
import { MenuItemModel } from '../../models/menu-item.model';
import { ItemService } from '../../../provider/item.service';
import {
  TimetableAndReservationService,
  TimeTableReservation
} from '../../../provider/timetable-and-reservation.service';
import { TranslateModel } from '../../../core/_base/layout/models/translate.model';
import { Subscription } from 'rxjs';
import { TranslationService } from '../../../provider/translation.service';
import { AppHotelModel } from '../../models/app-hotel.model';
import { AppHotelService } from '../../../provider/app-hotel.service';
import { UserService } from '../../../provider/user.service';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { BookDetailReservationGroupModel } from '../../models/BookDetailReservationGroup.model';

@Component({
  selector: 'c-timetable-reservations',
  templateUrl: './timetable-reservations.component.html',
  styleUrls: ['./timetable-reservations.component.scss']
})
export class TimetableReservationsComponent implements OnDestroy, OnInit {
  currentItemBookDetail: MenuItemBookDetailModel;
  currentItemBook: MenuItemBookModel;
  currentBookDetailReservationGroup: BookDetailReservationGroupModel;
  datas: TimeTableReservation[] = [];

  data: MenuItemModel = new MenuItemModel();
  activeDays = ['Mon,Tue,Wed,Thu,Fri,Sat,Sun'];

  days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];


  timetable = false;
  onDemand = false;
  linkExternal = false;
  bannerTable = false;
  activeId: string;

  startTime: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
  endTime: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };

  sub: Subscription;

  items: MenuItemModel[] = null;

  constructor(
    public dialog: MatDialog,
    public itemService: ItemService,
    public myService: TimetableAndReservationService,
    public tra: TranslationService,
    private hotelService: AppHotelService,
    private userService: UserService,
    private changeDetector: ChangeDetectorRef
  ) {
  }

  async ngOnInit() {
    this.items = await this.itemService.getItemsWithSectionId(157) as MenuItemModel[];
    this.myService.getData(this.items[0].id);
    this.itemService.getData(this.items[0].id, 'menu-item');
  }

  async deleteBook(bookId: number) {
    await this.myService.deleteItemBookData(bookId);
    await this.myService.getData(this.items[0].id);
    this.changeDetector.detectChanges();
  }

  languageTranslate(baseData: any, key: string, val: string, baseDataType?: string) {
    let translateModel: TranslateModel;
    try {
      translateModel = JSON.parse(val);
    } catch (e) {
      translateModel = new TranslateModel();
    }
    if (baseDataType == 'MenuItemBookDetail') {
      this.currentItemBookDetail = baseData;
    } else {
      this.currentItemBookDetail = undefined;
    }
    if (baseDataType == 'MenuItemBook') {
      this.currentItemBook = baseData;
    } else {
      this.currentItemBook = undefined;
    }
    if (baseDataType == 'BookDetailReservationGroup') {
      this.currentBookDetailReservationGroup = baseData;
    } else {
      this.currentBookDetailReservationGroup = undefined;
    }
    const dialogRef = this.dialog.open(LanguageTranslatePopup, {
      width: '700px', data: {
        ML: translateModel,
        baseData,
        key,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (this.currentItemBookDetail != undefined) {
        this.myService.putItemDetailData(this.currentItemBookDetail);
      }
      if (this.currentItemBook != undefined) {
        this.myService.putItemBookData(this.currentItemBook);
      }
      if (this.currentBookDetailReservationGroup != undefined) {
        this.myService.putReservationGroupData(this.currentBookDetailReservationGroup);
      }
    });
  }

  addNewScheduleInterval(bookId: number) {
    this.hotelService.getHotelInfo(this.userService.record_change$.getValue().app_hotel_id).subscribe(
      async (hotel: AppHotelModel) => {
        const scheduleLine = new MenuItemBookDetailModel();
        scheduleLine.menu_item_book_id = bookId;
        scheduleLine.start_time = new Date();
        scheduleLine.end_time = new Date();
        scheduleLine.menu_item_id = this.items[0].id
        scheduleLine.currency_code = hotel.currency_code;
        await this.myService.postItemDetailData(scheduleLine);
        await this.myService.getData(this.items[0].id);
        this.changeDetector.detectChanges();
      }
    );
  }

  deleteScheduleInterval(i: number, j: number) {
    this.myService.deleteItemDetailData(i, j);
  }

  async addSchedule() {
    const schedule = new MenuItemBookModel();

    for (const scheduleLine of this.datas) {
      if (scheduleLine.book.monday) {
        schedule.monday = false;
      }
      if (scheduleLine.book.tuesday) {
        schedule.tuesday = false;
      }
      if (scheduleLine.book.wednesday) {
        schedule.wednesday = false;
      }
      if (scheduleLine.book.thursday) {
        schedule.thursday = false;
      }
      if (scheduleLine.book.friday) {
        schedule.friday = false;
      }
      if (scheduleLine.book.saturday) {
        schedule.saturday = false;
      }
      if (scheduleLine.book.sunday) {
        schedule.sunday = false;
      }
    }

    schedule.menu_item_id = this.items[0].id;
    await this.myService.addItemBookDatas(schedule);
    await this.myService.getData(this.items[0].id);
    this.changeDetector.detectChanges();
    //   this.addNewScheduleInterval(this.myService.record_change$.getValue()[this.myService.record_change$.getValue().length - 1].book.id);
  }

  onChangeBookingSystem(bookingSystem: string) {
    this.data.booking_system = bookingSystem;
    this.itemService.putItem(this.data);
    switch (bookingSystem) {
      case 'only timetable':
        this.timetable = true;
        this.onDemand = false;
        this.linkExternal = false;
        this.bannerTable = false;
        break;
      case 'onDemand':
        this.onDemand = true;
        this.timetable = false;
        this.linkExternal = false;
        this.bannerTable = false;
        break;
      case 'link to external url':
        this.linkExternal = true;
        this.timetable = false;
        this.onDemand = false;
        this.bannerTable = false;
        break;
      case 'banner table':
        this.linkExternal = false;
        this.timetable = false;
        this.onDemand = false;
        this.bannerTable = true;
        break;
    }
  }

  checkDisabled(i: number, day: string): boolean {
    for (const item of this.datas) {
      if (item != this.datas[i] || (this.datas.length === 1 && this.activeDays[0].length === 3)) {
        switch (day) {
          case 'monday':
            if (item.book.monday) {
              return true;
            }
            break;
          case 'tuesday':
            if (item.book.tuesday) {
              return true;
            }
            break;
          case 'wednesday':
            if (item.book.wednesday) {
              return true;
            }
            break;
          case 'thursday':
            if (item.book.thursday) {
              return true;
            }
            break;
          case 'friday':
            if (item.book.friday) {
              return true;
            }
            break;
          case 'saturday':
            if (item.book.saturday) {
              return true;
            }
            break;
          case 'sunday':
            if (item.book.sunday) {
              return true;
            }
            break;
        }
      }
    }
    return false;
  }

  getTime(date: Date): string {
    return new Date(date).toISOString().split('T')[1].slice(0, 5);
  }

  async setTime($newTime: any, type: string, bookDetail: any) {
    if (type == 'start') {
      const oldDate = new Date(new Date()).toISOString().split('T')[0];
      bookDetail.start_time = new Date(oldDate + 'T' + $newTime + ':00Z');
      await this.myService.putItemDetailData(bookDetail);
    } else if (type == 'end') {
      const oldDate = new Date(new Date()).toISOString().split('T')[0];
      bookDetail.end_time = new Date(oldDate + 'T' + $newTime + ':00Z');
      await this.myService.putItemDetailData(bookDetail);
    } else if (type == 'group') {
      const oldDate = new Date(new Date()).toISOString().split('T')[0];
      bookDetail.default_time = new Date(oldDate + 'T' + $newTime + ':00Z');
      await this.myService.putReservationGroupData(bookDetail);
    }

    await this.myService.getData(this.items[0].id);
    this.changeDetector.detectChanges();
  }

  changeCustomValue(type: string, book: MenuItemBookModel) {
    switch (type) {
      case 'people':
        book.reservation_unit_custom = false;
        break;
      case 'custom':
        book.reservation_unit_custom = true;
        break;
    }
    this.myService.putItemBookData(book);
  }

  ngOnDestroy(): void {
    try {
      this.sub.unsubscribe();
    } catch {
    }
  }

  getDate(date: Date): string {
    return new Date(date).toISOString().split('T')[0];
  }

  setDate($newDate: any, type: string, bookDetail: MenuItemBookDetailModel) {
    const newDate = new Date($newDate.target.value).toISOString().split('T')[0];
    if (type == 'start') {
      const oldTime = new Date(bookDetail.start_time).toISOString().split('T')[1];
      bookDetail.start_time = new Date(newDate + 'T' + oldTime);
    } else if (type == 'end') {
      const oldTime = new Date(bookDetail.end_time).toISOString().split('T')[1];
      bookDetail.end_time = new Date(newDate + 'T' + oldTime);
    }
    this.myService.putItemDetailData(bookDetail);
  }

  deleteGroup(item: BookDetailReservationGroupModel) {
    this.myService.deleteReservationGroupData(item.id);
  }

  addGroup(bookDetailId) {
    const group = new BookDetailReservationGroupModel();
    group.book_detail_id = bookDetailId;
    group.menu_item_id = this.items[0].id;
    this.myService.postReservationGroupData(group);
  }
}
